// extracted by mini-css-extract-plugin
module.exports = {"OrderFooter":"OrderCreatePage_OrderFooter__JMQ_Q","ButtonRow":"OrderCreatePage_ButtonRow__1pKeF","Modal":"OrderCreatePage_Modal__1ad16"};